export default {
  "menu.insurance": "参保管理",
  "menu.reduction": "减员管理",
  "menu.recharge": "充值管理",
  "menu.invoice": "发票管理",
  "menu.welcome": "欢迎",
  "menu.more-blocks": "更多区块",
  "menu.home": "首页",
  "menu.admin": "管理页",
  "menu.admin.sub-page": "二级管理页",
  "menu.login": "登录",
  "menu.register": "注册",
  "menu.register-result": "注册结果",
  "menu.personal": "个人管理",
  "menu.personal.user-management": "用户管理",
  "menu.personal.user-profile": "用户档案",
  "menu.personal.order-management": "订单管理",
  "menu.enterprise": "企业管理",
  "menu.enterprise.user-management": "企业用户",
  "menu.account.logout": "退出登录",
  "menu.editor": "图形编辑器",
  "menu.editor.flow": "流程编辑器",
  "menu.editor.mind": "脑图编辑器",
  "menu.editor.koni": "拓扑编辑器",
};
